import React from "react";
import Chart from "chart.js/auto";
import { loadAdwords } from "../../data/supermetricsService";
import { loadFBaccounts } from "../../data/facebookService";

class DynamicDailyTrendChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {noMethodProvided: false};
  }
  componentDidMount() {
    switch (this.props.supermetricMethodName) {
      case "loadAdwords":
        loadAdwords(
          this.props.fields,
          null,
          ["Date asc"],
          1000,
          null,
          this.props.endpoints,
          this.props.dates,
          this.props.currentClient.clientCode,
          localStorage.getItem("accessToken")
        ).then((response) => {
          if (response.success) {
            response.result.data.shift();
            setTimeout(() => {
              this.props.graphFields.forEach((field, index) => {
                const lowerName = field.toLowerCase().split(" ").join("-");
                const lowerNameId = lowerName + "-graph";
                this.buildDailyChart(
                  field,
                  response.result.data,
                  index + 1,
                  lowerNameId
                ); /*title, inputData, index, elemId*/
              });
            }, 500);
            // this.setState({ metrics: response.result.data });
          }
        });
        break;
      case "loadFBaccounts":
        loadFBaccounts(
              this.props.endpoints,
              this.props.dates,
              this.props.currentClient.clientCode,
              localStorage.getItem("accessToken"),
              this.props.fields,
              1000
            ).then((response) => {
              if (response.success) {
                response.result.data.shift();
                setTimeout(() => {
                  this.props.graphFields.forEach((field, index) => {
                    const lowerName = field.toLowerCase().split(" ").join("-");
                    const lowerNameId = lowerName + "-graph";
                    this.buildDailyChart(
                      field,
                      response.result.data,
                      index + 1,
                      lowerNameId
                    ); /*title, inputData, index, elemId*/
                  });
                }, 500);
                // this.setState({ metrics: response.result.data });
              }
            });
        break;
      default:
        console.log("No Supermetric method provided");
        this.setState({ noMethodProvided: true });
        break;
    }
  }

  buildDailyChart(title, inputData, index, elemId) {
    if (inputData) {
      //   console.log('Input Data--', inputData);
      var data = [];
      var options = [...new Set(inputData.map((x) => x[0]))];
      for (var i = inputData.length - 1; i >= 0; i--) {
        data.push(inputData[i][index]);
      }
      data.reverse(); //options.reverse();
      var ctx = document.getElementById(elemId);
      new Chart(ctx, {
        type: "line",
        data: {
          labels: options,
          datasets: [
            {
              data: data,
              backgroundColor: "rgba(72, 152, 187, 0.3)",
              borderColor: "rgba(72, 152, 187, 1)",
              pointBackgroundColor: "rgba(190, 209, 47, 1)",
              pointRadius: 5,
              fill: "start",
            },
          ],
        },
        options: {
          plugins: {
            aspectRatio: 1,
            maintainAspectRatio: false,
            legend: { display: false },
            title: {
              display: true,
              text: title,
              fontSize: 16,
            },
          },
          layout: {
            padding: { left: 50, right: 50, top: 25, bottom: 25 },
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
          animations: {
            linear: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
        },
      });
    }
  }

  toggle(metric) {
    var button = document.querySelector(".breakdown button." + metric);
    var buttons = document.querySelectorAll(".breakdown button");
    var graph = document.querySelector(".graph-container." + metric);
    var graphs = document.querySelectorAll(".graph.analytics .graph-container");
    for (var i = buttons.length - 1; i >= 0; i--) {
      buttons[i].classList.remove("active");
      graphs[i].classList.remove("active");
    }
    button.classList.add("active");
    graph.classList.add("active");
  }

  render() {
    const noMethodProvided = this.state.noMethodProvided;
    const graphFields = this.props.graphFields || [];
    if (graphFields.length === 0) {
      return;
    }
    if(noMethodProvided) {
      return;
    }
    return (
      <React.Fragment>
        <section className="stats-graph">
          <div className="graph wide analytics">
            {graphFields.map((field, index) => {
              const lowerName = field.toLowerCase().split(" ").join("-");
              const lowerNameId = lowerName + "-graph";
              let activeClass = "";
              if (index === 0) {
                activeClass = "active";
              }

              return (
                <div
                  className={`graph-container ${lowerName} ${activeClass}`}
                  key={lowerNameId}
                >
                  <canvas className="chart" id={lowerNameId} />
                </div>
              );
              {
                (" ");
              }
            })}
          </div>
          <div className="breakdown">
            <p className="title"> Metrics </p>{" "}
            <div className="graph-controls">
              {graphFields.map((field, index) => {
                const lowerName = field.toLowerCase().split(" ").join("-");
                let activeClass = "";
                if (index === 0) {
                  activeClass = "active";
                }
                return (
                  <button
                    className={`wide white ${lowerName} ${activeClass}`}
                    onClick={() => this.toggle(lowerName)}
                    key={lowerName}
                  >
                    {" "}
                    {field}{" "}
                  </button>
                );
              })}
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default DynamicDailyTrendChart;
